import { FALLBACK_PRODUCT_IMAGE } from "lib/utils/constants";
import { classNames, getModifiedImageUrl } from "lib/utils/helpers";
import React, { useMemo } from "react";
import { getTextColorByBrightness } from "@shopflo/ui/utils";

interface ProductCardImageProps {
  imageLink?: string;
  backgroundColor?: string;
  children?: React.ReactNode;
  variant?: "default" | "large";
}

const ProductCardImage: React.FC<ProductCardImageProps> = ({
  imageLink,
  backgroundColor,
  children,
  variant = "default",
}) => {
  const imageUrl = useMemo(
    // Empty-cart thumbs are 110px; `_small` (~100px) looks soft on retina — use `_medium` (~240px).
    () => getModifiedImageUrl(imageLink, FALLBACK_PRODUCT_IMAGE, variant === "large" ? "_medium" : "_small"),
    [imageLink, variant],
  );
  const isLarge = variant === "large";

  return (
    <div
      className={classNames(
        "relative aspect-square shrink-0 overflow-hidden",
        isLarge
          ? "h-[110px] w-[110px] rounded-xl bg-cream shadow-[0_0_0_1px_rgb(var(--flo-ink-color)/0.1)_inset]"
          : "h-[68px] w-[68px] rounded-lg border-1",
      )}
      style={
        isLarge
          ? undefined
          : {
              borderColor: getTextColorByBrightness({ bgHexColor: backgroundColor ?? "#FFFFFF", lightOpacity: 24 }),
            }
      }>
      <img
        src={imageUrl}
        onError={(e) => {
          e.currentTarget.src = FALLBACK_PRODUCT_IMAGE;
        }}
        alt="Cart Item"
        className="object-cover h-full w-full"
        draggable={false}
      />
      {children}
    </div>
  );
};

export default ProductCardImage;
